import Vue from "vue";

import axios from "axios";

export default {
  getters: {
    memberName: (state, getters, rootState) => {
      let name = "";
      if (rootState.member != null) {
        name = rootState.member.MemberFirstName.trim();
        if (name == "") name = rootState.member.MemberLastName.trim();
      }
      return name;
    },

    memberFullName: (state, getters, rootState) => {
      let name = "";
      if (rootState.member != null) {
        name = rootState.member.MemberFirstName.trim();
        name += (name == "" ? "" : " ") + rootState.member.MemberLastName.trim();
      }
      return name;
    },

    memberPhoneId: (state, getters, rootState) => {
      let phoneId = "";
      if (rootState.member != null) {
        phoneId = rootState.member.PhoneId;
      }
      return phoneId;
    },

    memberEmail: (state, getters, rootState) => {
      let email = "";
      if (rootState.member != null) {
        email = rootState.member.MemberEMail;
      }
      return email;
    },

    memberCompanyCode: (state, getters, rootState) => {
      let n_companyCode = null;
      if (rootState.member != null && rootState.member.CompanyCode != null) {
        n_companyCode = rootState.member.CompanyCode;
      }

      return n_companyCode;
    },

    memberCompanyName: (state, getters, rootState) => {
      let n_companyName = null;
      if (rootState.member != null && rootState.member.CompanyName != null) {
        n_companyName = rootState.member.CompanyName;
      }

      return n_companyName;
    },

    memberMerchants: (state, getters, rootState) => {
      let n_merchants = null;
      if (rootState.member != null && rootState.member.Merchants != null) {
        n_merchants = rootState.member.Merchants;
      }

      return n_merchants;
    },

    memberStripeEnabled: (state, getters) => {
      let merchants = getters.memberMerchants;
      return merchants != null && merchants.includes("stripe");
    },

    memberGlobalPaymentEnabled: (state, getters) => {
      let merchants = getters.memberMerchants;
      return merchants != null && merchants.includes("globalPayment");
    },

    giftcardBalance: (state, getters, rootState) => {
      let giftcardBalance = 0;
      if (rootState.giftcards) {
        rootState.giftcards.forEach(r => {
          giftcardBalance += r.CurBalance;
        });
      }

      return giftcardBalance;
    },
  },

  actions: {
    getGiftcards(context, payload) {
      console.log("member", context.rootState.member);
      console.log("payload", payload);

      let memberCode;
      if (context.rootState.member != null) memberCode = context.rootState.member.MemberCode;

      let jreq = {
        sessionId: context.rootState.appSessionID,
        sessionKey: context.getters.serviceSessionKey,
        list: [{ MemberCode: memberCode }],
        debug: Vue.prototype.$devEnv,
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(context.rootState.dcApiUrl + "giftcard", request, context.rootState.httpReqOpt)
        .then(result => result.data)
        .then(data => {
          let listData = data.list[0];
          if (listData.result == "ok") {
            context.commit("giftcards", listData.record == null ? [] : listData.record);
            return true;
          } else {
            context.commit("giftcards", []);
            return false;
          }
        })
        .catch(error => {
          console.log(error);
          context.commit("giftcards", []);
          return false;
        });
    },
  },
};
